import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  bankList: [],
};

const bankSlice = createSlice({
  name: "bank",
  initialState,
  reducers: {
    addBankList: (state, action) => {
      state.bankList = action.payload;
    },
    removeBankList: (state) => {
      state.bankList = [];
    }
  },
});
export const {
  addBankList,
  removeBankList
} = bankSlice.actions;
export default bankSlice.reducer;
